import React, { Component } from "react";
import { Link } from "react-router-dom";
import { setLearningCategoryTitle, setCategoryId } from "../../../../../localstorage-service";
import * as CONSTANTS from "../../../../../constants";

class LearningCategory extends Component {
  learningCategoryClicked(title, catid) {
    setLearningCategoryTitle(title);
    setCategoryId(catid);
  }
  render() {
    return (
      <li style={{ background: `url(${CONSTANTS.API_BASE_URL}${this.props.imagepath}) no-repeat center center` }}>
        <Link
          className={!this.props.isenabled ? "disabled" : ""}
          onClick={() => this.learningCategoryClicked(this.props.title, this.props.categoryid)}
          to={{ pathname: this.props.url, state: { title: this.props.title, id: this.props.categoryid } }}
        >
          <p>{this.props.title}</p>
        </Link>
      </li>
    );
  }
}

export default LearningCategory;



// WEBPACK FOOTER //
// ./src/containers/User/Learning/LearningCategories/LearningCategory/LearningCategory.js